"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2597],{

/***/ 50859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getListSearchHistory; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const getListSearchHistory = async (header)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/projects/search-history");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GET */ .Z.GET, path, null, header);
    return response;
};


/***/ }),

/***/ 36361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ saveSearchHistory; }
/* harmony export */ });
/* harmony import */ var _api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65255);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_request_method__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17028);
/* harmony import */ var url_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26509);




const saveSearchHistory = async (params, headers)=>{
    const path = (0,url_join__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("v1/projects/savehistory");
    const response = await (0,_api_utils_fetch_api__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)(()=>({
            apiUrl: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG
        }))(_constants_request_method__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST */ .Z.POST, path, params, headers);
    return response;
};


/***/ }),

/***/ 44217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33172);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _NotificationPopupContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65037);
/* harmony import */ var _vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77027);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);








const NotiMobile = ()=>{
    const { token , user  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)();
    const [countNoti, setCountNoti] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const seenAllNoti = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(async ()=>{
        if (token) try {
            await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].request */ .Z.request({
                method: "POST",
                url: "/v1/notifications/view",
                baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
                headers: {
                    Authorization: "Bearer ".concat(token)
                }
            });
            setCountNoti(0);
        } catch (error) {}
    }, [
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (token) axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].request */ .Z.request({
            baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
            url: "/v1/notifications/count",
            headers: {
                Authorization: "Bearer ".concat(token)
            }
        }).then((res)=>{
            setCountNoti(res.data.count);
        });
    }, [
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (countNoti && open) seenAllNoti();
    }, [
        open,
        seenAllNoti,
        countNoti
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (open) (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__/* .lockScroll */ .dg)();
        else (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__/* .unlockScroll */ .pX)();
        return ()=>{
            (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_5__/* .unlockScroll */ .pX)();
        };
    }, [
        open
    ]);
    return user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("fixed w-screen h-screen  top-0 bg-white z-20 duration-300", open ? "left-0 " : "left-full"),
                children: open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NotificationPopupContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    titleClassName: "!text-fs-20",
                    allowBack: true,
                    onClose: ()=>setOpen(false),
                    onBack: ()=>setOpen(false)
                }) : null
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "rounded-full bg-blue-50 w-9 h-9 flex items-center justify-center relative cursor-pointer",
                onClick: ()=>setOpen(true),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-notifications text-fs-20 text-blue-500"
                    }),
                    countNoti ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 -right-2 text-white bg-red-500 rounded-full text-fs-12 px-1",
                        children: countNoti
                    }) : null
                ]
            })
        ]
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (NotiMobile);


/***/ }),

/***/ 23768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_PopOver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20951);
/* harmony import */ var _constants_common_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17785);
/* harmony import */ var _utils_datetime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61297);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _AvatarWithName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7869);







const UserTime = (param)=>{
    let { src , alt , name , subTitle , textClass , className , subTitleClass , imageClass , imageProps , size , time , haveAction =false , actionTitle , actionIcon , aboutProject , maxLengthName , ...otherProps } = param;
    const textSize = size === "small" ? "text-fs-14" : "text-base";
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex items-center", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-max shrink-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AvatarWithName__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    imageClass: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(imageClass ? imageClass : "!w-6 !h-6"),
                    imageProps: {
                        resizeOnFly: false
                    },
                    className: "flex-0 ",
                    avatarOnly: true,
                    alt: name !== null && name !== void 0 ? name : "Ẩn danh",
                    name: name,
                    src: src ? src : name ? null : _constants_common_constant__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_IMAGE_CARD */ .mq
                })
            }),
            haveAction ? name || time ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "ml-1 flex flex-col ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-1.5 flex-wrap",
                        children: [
                            maxLengthName && (name === null || name === void 0 ? void 0 : name.length) > maxLengthName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopOver__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                trigger: "hover",
                                dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                    children: name
                                }),
                                position: "top-left",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("font-semibold break-word", textSize, textClass),
                                    children: name.substring(0, maxLengthName) + "..."
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("font-semibold break-word", textSize, textClass),
                                children: name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-grey-600 text-fs-14 shrink-0",
                                children: actionTitle
                            }),
                            actionIcon,
                            aboutProject
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-grey-400 flex-0 text-fs-12",
                        children: mounted ? (0,_utils_datetime__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeTime */ .ni)(time) : null
                    })
                ]
            }) : null : name || time ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    maxLengthName && (name === null || name === void 0 ? void 0 : name.length) > maxLengthName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopOver__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        trigger: "hover",
                        dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                            children: name
                        }),
                        position: "top-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("font-semibold ml-2 break-word ", textSize, textClass),
                            children: name.substring(0, maxLengthName) + "..."
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("font-medium md:font-semibold ml-2 break-word line-clamp-1 flex-1", textSize, textClass),
                        children: name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[5px] h-[5px] rounded-full bg-grey-400 flex-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-grey-400 flex-0 text-fs-12 md:text-fs-14",
                        children: mounted ? (0,_utils_datetime__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeTime */ .ni)(time) : null
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserTime);


/***/ }),

/***/ 10858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LocationSelect_PopupSelectLocation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button.tsx + 1 modules
var Button = __webpack_require__(40364);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/modules/Mobile/Home/HeaderHome/LocationSelect/SelectCity.tsx







/* eslint-disable @next/next/no-img-element */ const SelectCity = (param)=>{
    let { valueLocation , setValueLocation , setActiveTab , onConfirm  } = param;
    const [data, setData] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const [value, setValue] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setValue(valueLocation.city);
    }, [
        valueLocation
    ]);
    const listDataRender = (0,react.useMemo)(()=>{
        var _unionBy;
        return (_unionBy = (0,lodash.unionBy)(value, data, "_id")) === null || _unionBy === void 0 ? void 0 : _unionBy.filter((item)=>{
            return item === null || item === void 0 ? void 0 : item.title.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        });
    }, [
        data,
        search,
        value
    ]);
    const getData = (0,react.useCallback)(async ()=>{
        setLoading(true);
        try {
            var _res_data;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/cities",
                params: {
                    limit: 500
                }
            });
            setData((_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.results);
        } catch (error) {} finally{
            setLoading(false);
        }
    }, []);
    (0,react.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center mx-4 px-3 py-2 bg-[rgba(0,0,0,0.05)] rounded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-search text-fs-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: search,
                        onChange: (e)=>{
                            var _e_target_value;
                            return setSearch((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100));
                        },
                        placeholder: "T\xecm Tỉnh/Th\xe0nh phố",
                        className: "h-[28px] mr-5 w-full text-base bg-transparent"
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full flex justify-center py-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dot-flashing"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full h-full overflow-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    setValueLocation({
                                        city: [],
                                        district: [],
                                        ward: []
                                    });
                                },
                                className: "py-3 px-4 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer border-b border-b-grey-200 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: (0,clsx_m/* default */.Z)("mrv mrv-check text-fs-24 mr-2", !(value === null || value === void 0 ? void 0 : value.length) ? "text-blue-500" : "text-transparent")
                                    }),
                                    "To\xe0n quốc"
                                ]
                            }),
                            listDataRender === null || listDataRender === void 0 ? void 0 : listDataRender.map((city)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    onClick: ()=>{
                                        // setValueLocation({
                                        //   city: [city],
                                        //   district: [],
                                        //   ward: [],
                                        // });
                                        setValue([
                                            city
                                        ]);
                                    },
                                    className: "py-3 px-4 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer border-b border-b-grey-200 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (0,clsx_m/* default */.Z)("mrv mrv-check text-fs-24 mr-2", (value === null || value === void 0 ? void 0 : value.find((e)=>e._id === city._id)) ? "text-blue-500" : "text-transparent")
                                        }),
                                        city === null || city === void 0 ? void 0 : city.name
                                    ]
                                }, city._id);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex py-2 px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !text-grey-600 !h-10 foucus:!border-tranparent hover:!border-transparent",
                                btnType: "link",
                                onClick: ()=>{
                                    setValue([]);
                                },
                                children: [
                                    "Đặt lại",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !h-10",
                                btnType: "filled",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: value,
                                        district: [],
                                        ward: []
                                    });
                                    if (onConfirm) {
                                        onConfirm({
                                            city: value,
                                            district: [],
                                            ward: []
                                        });
                                    } else if (value.length) setActiveTab("district");
                                    else setActiveTab(null);
                                },
                                children: [
                                    "X\xe1c nhận",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LocationSelect_SelectCity = (SelectCity);

// EXTERNAL MODULE: ./src/utils/number.ts + 1 modules
var number = __webpack_require__(1495);
;// CONCATENATED MODULE: ./src/modules/Mobile/Home/HeaderHome/LocationSelect/SelectDistrict.tsx








/* eslint-disable @next/next/no-img-element */ const SelectDistrict_SelectCity = (param)=>{
    let { valueLocation , setValueLocation , setActiveTab , onConfirm  } = param;
    const [data, setData] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const [value, setValue] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setValue(valueLocation.district);
    }, [
        valueLocation
    ]);
    const listDataRender = (0,react.useMemo)(()=>{
        return (0,lodash.unionBy)(value, data, "_id").filter((e)=>e.title.toLowerCase().includes(search.toLowerCase()));
    }, [
        data,
        search,
        value
    ]);
    const getData = (0,react.useCallback)(async ()=>{
        setLoading(true);
        try {
            var _valueLocation_city, _res_data;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/districts",
                method: "post",
                data: {
                    limit: 500,
                    city: valueLocation === null || valueLocation === void 0 ? void 0 : (_valueLocation_city = valueLocation.city) === null || _valueLocation_city === void 0 ? void 0 : _valueLocation_city[0]._id
                }
            });
            setData((_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.results);
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        valueLocation === null || valueLocation === void 0 ? void 0 : valueLocation.city
    ]);
    (0,react.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center mx-4 px-3 py-2 bg-[rgba(0,0,0,0.05)] rounded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-search text-fs-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: search,
                        onChange: (e)=>{
                            var _e_target_value;
                            return setSearch((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100));
                        },
                        placeholder: "T\xecm Quận/Huyện",
                        className: "h-[28px] mr-5 w-full text-base bg-transparent"
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full flex justify-center py-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dot-flashing"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-full overflow-auto",
                        children: listDataRender === null || listDataRender === void 0 ? void 0 : listDataRender.map((district)=>{
                            const isSelect = value.find((item)=>item._id === district._id);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: ()=>{
                                    setValue(isSelect ? value === null || value === void 0 ? void 0 : value.filter((item)=>item._id !== district._id) : [
                                        ...value,
                                        district
                                    ]);
                                },
                                className: "py-3 px-4 flex items-center duration-300 cursor-pointer border-b border-b-grey-200 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: (0,clsx_m/* default */.Z)("mrv   text-fs-24 mr-2", isSelect ? "mrv-check_box text-blue-500" : "mrv-check_box_outline_blank")
                                    }),
                                    (0,number/* isNumeric */.kE)(district === null || district === void 0 ? void 0 : district.name) ? district.title : district === null || district === void 0 ? void 0 : district.name
                                ]
                            }, district._id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex py-2 px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !text-grey-600",
                                btnType: "link",
                                onClick: ()=>{
                                    setValue([]);
                                },
                                children: [
                                    "Đặt lại",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center",
                                btnType: "filled",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: value,
                                        ward: []
                                    });
                                    if (onConfirm) onConfirm({
                                        city: valueLocation.city,
                                        district: value,
                                        ward: []
                                    });
                                    else if (value.length) setActiveTab("ward");
                                },
                                children: [
                                    "X\xe1c nhận",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SelectDistrict = (SelectDistrict_SelectCity);

// EXTERNAL MODULE: ./src/constants/common-constant.ts
var common_constant = __webpack_require__(17785);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
;// CONCATENATED MODULE: ./src/modules/Mobile/Home/HeaderHome/LocationSelect/SelectWard.tsx










/* eslint-disable @next/next/no-img-element */ const SelectWard_SelectCity = (param)=>{
    let { valueLocation , setValueLocation , setActiveTab , onConfirm  } = param;
    const [data, setData] = (0,react.useState)({
        results: [],
        totalResults: 0,
        totalPages: 0,
        page: 1
    });
    const [loading, setLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const [value, setValue] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setValue(valueLocation.ward);
    }, [
        valueLocation
    ]);
    const listDataRender = (0,react.useMemo)(()=>{
        return (search === null || search === void 0 ? void 0 : search.length) ? data.results : (0,lodash.unionBy)(valueLocation.ward, data.results, "_id");
    }, [
        data.results,
        search,
        valueLocation.ward
    ]);
    const getData = (0,react.useCallback)(async (params)=>{
        setLoading(true);
        try {
            var _valueLocation_district;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/wards",
                method: "post",
                data: {
                    limit: 10,
                    page: 1,
                    name: search,
                    sort: "name:asc",
                    district: (_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.map((e)=>e._id),
                    ...params
                }
            });
            setData({
                ...res.data
            });
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        search,
        valueLocation.district
    ]);
    const loadMoreData = (0,react.useCallback)(async (page)=>{
        setLoading(true);
        try {
            var _valueLocation_district;
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/wards",
                method: "post",
                data: {
                    limit: 10,
                    page: page !== null && page !== void 0 ? page : 1,
                    name: search,
                    sort: "name:asc",
                    district: (_valueLocation_district = valueLocation.district) === null || _valueLocation_district === void 0 ? void 0 : _valueLocation_district.map((e)=>e._id)
                }
            });
            setData({
                ...res.data,
                results: page ? [
                    ...data.results,
                    ...res.data.results
                ] : res.data.results
            });
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        data.results,
        search,
        valueLocation.district
    ]);
    (0,react.useEffect)(()=>{
        getData();
    }, []);
    const timeoutSearch = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center mx-4 px-3 py-2 bg-[rgba(0,0,0,0.05)] rounded",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-search text-fs-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: search,
                        onChange: (e)=>{
                            var _e_target_value;
                            clearTimeout(timeoutSearch.current);
                            setSearch((_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100));
                            if (!loading) timeoutSearch.current = setTimeout(()=>{
                                var _e_target_value;
                                getData({
                                    name: (_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100)
                                });
                            }, common_constant/* TIMEOUT_LOAD_SEARCH */.XO);
                        },
                        onKeyUp: (e)=>{
                            if (e.key === "Enter" && !loading) {
                                var _e_target_value;
                                clearTimeout(timeoutSearch.current);
                                getData({
                                    name: (_e_target_value = e.target.value) === null || _e_target_value === void 0 ? void 0 : _e_target_value.slice(0, 100)
                                });
                            }
                        },
                        placeholder: "T\xecm Phường/X\xe3",
                        className: "h-[28px] mr-5 w-full text-base bg-transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("w-full h-full overflow-auto px-3"),
                        id: "scrollablePopup",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                            dataLength: data.results.length || 0,
                            hasMore: data.page < data.totalPages,
                            next: ()=>{
                                loadMoreData(data.page + 1);
                            },
                            scrollableTarget: "scrollablePopup",
                            className: " md:gap-4 gap-1 overflow-auto w-full",
                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dot-flashing"
                                })
                            }),
                            children: listDataRender === null || listDataRender === void 0 ? void 0 : listDataRender.map((ward)=>{
                                const isSelect = value.find((item)=>item._id === ward._id);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: ()=>{
                                        setValue(isSelect ? value === null || value === void 0 ? void 0 : value.filter((item)=>item._id !== ward._id) : [
                                            ...value,
                                            ward
                                        ]);
                                    },
                                    className: "py-3 flex items-center hover:bg-[rgba(0,0,0,0.05)] duration-300 cursor-pointer ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (0,clsx_m/* default */.Z)("mrv   text-fs-24 mr-2", isSelect ? "mrv-check_box text-blue-500" : "mrv-check_box_outline_blank")
                                        }),
                                        (0,number/* isNumeric */.kE)(ward === null || ward === void 0 ? void 0 : ward.name) ? ward.title : ward === null || ward === void 0 ? void 0 : ward.name
                                    ]
                                }, ward._id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex py-2 px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center !text-grey-600",
                                btnType: "link",
                                onClick: ()=>{
                                    setValue([]);
                                },
                                children: [
                                    "Đặt lại",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "w-full flex justify-center",
                                btnType: "filled",
                                onClick: ()=>{
                                    setValueLocation({
                                        city: valueLocation.city,
                                        district: valueLocation.district,
                                        ward: value
                                    });
                                    if (onConfirm) onConfirm({
                                        city: valueLocation.city,
                                        district: valueLocation.district,
                                        ward: value
                                    });
                                    else setActiveTab(null);
                                },
                                children: [
                                    "X\xe1c nhận",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SelectWard = (SelectWard_SelectCity);

;// CONCATENATED MODULE: ./src/modules/Mobile/Home/HeaderHome/LocationSelect/PopupSelectLocation.tsx






/* eslint-disable @next/next/no-img-element */ const tabs = [
    {
        label: "Tỉnh/Th\xe0nh phố",
        key: "city",
        child: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelect_SelectCity, {})
    },
    {
        label: "Quận/Huyện",
        key: "district",
        child: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDistrict, {})
    },
    {
        label: "Phường/X\xe3",
        key: "ward",
        child: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectWard, {})
    }
];
const PopupSelectLocation = (param)=>{
    let { valueLocation , setValueLocation , onConfirm , activeTab , setActiveTab  } = param;
    // const
    const activeItem = (0,react.useMemo)(()=>{
        return tabs.find((tab)=>tab.key === activeTab);
    }, [
        activeTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("px-4 py-3 font-medium cursor-pointer  bg-grey-50 duration-300 text-black flex justify-center w-full rounded-t-[1.5rem]"),
                        children: activeItem === null || activeItem === void 0 ? void 0 : activeItem.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer",
                        onClick: ()=>setActiveTab(null),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-close text-fs-24 font-medium"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[30rem] pt-3 overflow-auto flex flex-col ",
                children: activeItem ? /*#__PURE__*/ (0,react.cloneElement)(activeItem === null || activeItem === void 0 ? void 0 : activeItem.child, {
                    valueLocation,
                    setValueLocation,
                    setActiveTab,
                    onConfirm
                }) : null
            })
        ]
    });
};
/* harmony default export */ var LocationSelect_PopupSelectLocation = (PopupSelectLocation);


/***/ }),

/***/ 47565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3524);
/* harmony import */ var _components_VideoPlayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19534);
/* harmony import */ var _constants_file__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32336);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);





const MAX_FILE_SHOW = 7;
const ListFileReview = (param)=>{
    let { data , className , maxFileShow =MAX_FILE_SHOW  } = param;
    var _data_media, _data_media1;
    return ((_data_media = data.media) === null || _data_media === void 0 ? void 0 : _data_media.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("py-2 rounded-lg text-fs-12 text-grey-600 flex overflow-auto flex-wrap gap-2 w-full", className),
        children: (_data_media1 = data.media) === null || _data_media1 === void 0 ? void 0 : _data_media1.slice(0, maxFileShow + 1).map((file, id)=>{
            var _file_name_split;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative group cursor-pointer", file.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.image */ .r.image) || file.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.video */ .r.video) ? "can-preview-upload" : "default-file"),
                children: [
                    file.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.image */ .r.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[3rem] h-[3rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: " text-fs-12 w-full h-full overflow-hidden rounded",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MeeyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: "object-cover w-full h-full",
                                src: file.uri,
                                alt: file.name,
                                resizeOnFly: !!(file === null || file === void 0 ? void 0 : file.uri),
                                resizeOptions: {
                                    width: 48,
                                    height: 48
                                }
                            })
                        })
                    }) : file.name.match(_constants_file__WEBPACK_IMPORTED_MODULE_3__/* .fileType.video */ .r.video) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[3rem] h-[3rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: " text-fs-12 w-full h-full overflow-hidden rounded-md",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VideoPlayer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    options: {
                                        autoplay: false,
                                        controls: false,
                                        responsive: true,
                                        fluid: true,
                                        preload: "metadata",
                                        sources: [
                                            {
                                                src: file.urlVod
                                            }
                                        ]
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "mrv mrv-play_arrow text-white text-fs-24 font-bold"
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-[3rem] h-[3rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer border border-transparent border-dashed",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-[0_0_28px] w-full flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "-rotate-90 w-fit flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "mrv mrv-attachment text-fs-20 text-grey-600"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-fs-10 text-grey-600",
                                        children: [
                                            ".",
                                            (_file_name_split = file.name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1.5 px-2 overflow-hidden rounded-b-md"
                            })
                        ]
                    }),
                    id === maxFileShow && data.media.length > maxFileShow + 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "cursor-pointer absolute w-full h-full top-0 bg-[rgba(0,0,0,0.2)] flex items-center justify-center z-10 rounded-md duration-300 text-base font-semibold text-white",
                        children: [
                            "+",
                            data.media.length - (maxFileShow + 1)
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "mrv mrv-preview text-white text-fs-20"
                        })
                    })
                ]
            }, file.s3Key);
        })
    }, data._id) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (ListFileReview);


/***/ })

}]);